module.exports = __webpack_public_path__ + "img/4.934bc36b.png";